import React from 'react'
import type { Icon } from 'shared/utils'
import { colors } from 'shared/assets/styles'

const { grey } = colors

const RadioChecked = (props: Icon) => {
    const { color = grey, size = 24, className = 'radio-checked' } = props
    return (
        <svg className={className} width={size} height={size}>
            <path
                fill={color}
                d="M9.062 9.083a4.165 4.165 0 0 0 .007 5.893 4.17 4.17 0 0 0 5.895-.008 4.165 4.165 0 0 0 0-5.885 4.17 4.17 0 0 0-5.902 0zm10.004-4.166C15.152 1.018 8.818 1.029 4.918 4.94c-3.9 3.912-3.89 10.244.024 14.142 3.904 3.89 10.22 3.89 14.124 0a9.997 9.997 0 0 0 .025-14.125l-.025-.041zm-1.4 12.736a8.006 8.006 0 0 1-11.318.007A7.998 7.998 0 0 1 6.34 6.347a8.006 8.006 0 0 1 11.325 0 7.944 7.944 0 0 1 0 11.306z"
            />
        </svg>
    )
}

export { RadioChecked }
